<template>
    <div class="columnchamado">
        <Tables ref="TabledetailsTabReforco"
                  :columns="['Valor','Data Inclusão','Status', '']"
                  :key="0"
                   v-on:Load="GetReforco"
                  :newHeaderStatus="true"
                >
                  <tr v-for="(detail,index) in details" :key="index" >
                    <TableColumn
                      :IsText="true"
                      :value="formatMoney(detail.valorReforco == null ? 0 : detail.valorReforco)"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.dataAcaoFormatada"
                    />
                    <TableColumn
                      :IsText="true"
                      :status="1"
                      :value="detail.situacao"
                    />
                    <TableColumn
                  :IsActiveButton="detail.situacao == 'INATIVO' || detail.situacao == 'ATIVO'? false : hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)"
                  :newEditGama="detail.situacao == 'INATIVO' || detail.situacao == 'ATIVO' ? false : hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)"
                  :IsExpenseTravel="false"
                  :IsOnlyDownload="true"
                  :IsOnlyDownloadSomente="detail.situacao == 'INATIVO' || detail.situacao == 'ATIVO'? true : false"
                  v-on:Download="verificacaoArquivoidDomwloadReforco(detail)"
                  :HasChange="hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)"
                  v-on:Delete="openModalDeleteReforco(detail)"
                  v-on:Edit="openModalReinforcementEdit(detail)"
                  />
                </tr>
                <template v-if="hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL)" #ButtonsAprova>
                  <div class="w-100" v-if="bloqueiCriacaoReforco === false">
                    <button class="btn-head" @click="openModalReinforcementValue(details)"><i class="fas fa-plus"></i></button>
                  </div>
              </template>
        </Tables>
    </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import ReinforcementRepository from '@/shared/http/repositories/access/reinforcement'
import AutocompleteZ from '@/components/forms/AutocompleteZ.vue'
import PermissionMixin from '@/store/module/permission/mixin'
import { toast, loading } from '@/shared/utils/UIHelper'
import Tools from '@/components/tools/Tools.js'
export default {
  name: 'tablecollaborator',
  mixins: [ActionsForm, PermissionMixin],
  props: {
    funcionarioId: {
      type: String,
      default: ''
    },
    empresaId: {
      type: String,
      default: ''
    },
    AtualizaReforco: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AutocompleteZ
  },
  data () {
    return {
      details: [],
      bloqueiCriacaoReforco: false,
      infoFuncionario: {},
      funciId: null,
      Download: {},
      editar: null
    }
  },
  mounted () {
    this.GetReforco()
  },
  watch: {
    'AtualizaReforco' () {
      console.log('atualizareforco' + this.AtualizaReforco + this.funcionarioId)
      this.GetReforco()
    },
    'funcionarioId' (value) {
      this.funciId = value
    }
  },
  methods: {
    openModalDeleteReforco (ReforcoId) {
      loading.push()
      ReinforcementRepository.ExclusaoReforco(ReforcoId.reforcoid, this.empresaId)
        .then(Response => {
          if (Response.data) {
            loading.close()
            this.GetReforco(ReforcoId.funcionarioID)
            toast.success('Reforço excluida com sucesso')
          }
        })
        .catch((Error) => {
          if (Error.response.data !== null && Error.response.data !== undefined) {
            toast.warning(Error.response.data)
            loading.pop()
            this.$refs['add-despesa'].hide()
          } else {
            loading.pop()
            this.$refs['add-despesa'].hide()
            toast.warning('Erro ao excluir')
          }
        })
    },
    openModalReinforcementEdit (FuncionarioId) {
      this.editar = FuncionarioId == null ? '' : FuncionarioId
      this.$emit('editarReforco', this.editar)
    },
    verificacaoArquivoidDomwloadReforco (obj) {
      this.Download = obj == null ? {} : obj
      this.$emit('ArquivoDownload', this.Download)
    },
    openModalReinforcementValue (obj) {
      this.infoFuncionario = obj == null ? {} : obj
      this.$emit('CriaReforco', this.infoFuncionario)
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    GetReforco () {
      loading.push()
      ReinforcementRepository.GetReforcoById(this.funcionarioId, this.empresaId, this.$refs.TabledetailsTabReforco.pagingLimit, this.$refs.TabledetailsTabReforco.pagingIndex)
        .then(Response => {
          this.$refs.TabledetailsTabReforco.LoadAllByData(Response)
          this.details = Response.data.data
          loading.pop()
          if (this.details != null || this.details !== undefined) {
            const temStatus1 = Response.data.data.some(obj => obj.status === 1 || obj.situacao === 'AG. APROVAÇÃO')
            if (temStatus1 === true) {
              this.bloqueiCriacaoReforco = true
            } else {
              this.bloqueiCriacaoReforco = false
            }
          }
        })
    }
  }
}

</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/private/miscellaneousreimbursement/components/tablecollaborator/tableReinforcement.vue